import React, { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import './index.less';

interface Props {
    children: ReactElement;
    title: string;
}

const SuccessModal: FC<Props> = (props) => {
    const { children, title } = props;

    return (
        <div className="kf_success_modal">
            <div className="success_title">{title}</div>
            {children}
            <div className="success_btn">
                <Link to="/kf/kfTrackIndex">我的服务跟踪</Link>
            </div>
        </div>
    )
}

export default SuccessModal;